exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background[data-v-371ecf88]{padding:0px 18px}.midButton[data-v-371ecf88]{width:350px;margin-top:20px}.table-hr[data-v-371ecf88]{border-left:3px solid #EBEEF5}.divider[data-v-371ecf88]{height:10px;background-color:#EBEEF5;border:none}.title-page[data-v-371ecf88]{color:#b8b5b5}\n", ""]);

// exports
